export default "__VITE_ASSET__2d3452d3__"